// Polyfill __name function used by esbuild-bundled dependencies.
// This file runs synchronously before ANY client component code executes.

// Sentry client-side tracking temporarily disabled to reduce CF Workers bundle size.
// Re-enable when upgrading to CF Workers Paid plan (10 MiB limit).

type NamedFunction = Function & { name?: string };

const defineName = <T extends NamedFunction>(fn: T, name: string): T => {
  if (typeof name === "string" && name.length > 0) {
    try {
      Object.defineProperty(fn, "name", { value: name, configurable: true });
    } catch {
      // Ignore environments where Function#name cannot be redefined
    }
  }
  return fn;
};

const targets = [
  globalThis,
  typeof self !== "undefined" ? self : null,
  typeof window !== "undefined" ? window : null,
];

for (const target of targets) {
  if (target && typeof (target as Record<string, unknown>).__name !== "function") {
    try {
      (target as Record<string, unknown>).__name = defineName;
    } catch {
      // Ignore if assignment is blocked
    }
  }
}

// Export router transition hook — noop without Sentry
type RouterTransitionHook = (href: string, navigationType: string) => void;
export const onRouterTransitionStart: RouterTransitionHook = () => {};
